import { UnresolvedIdpValue } from 'utils/api/modules/user/user.types';

import { IdpField } from '../components/IdpManaged';

import { useStore } from 'utils/hooks/store';

export interface MappedFields {
  isMapped: (field: IdpField) => boolean;
  unresolvedFor: (field: IdpField) => UnresolvedIdpValue | undefined;
  hasAny: boolean;
  scimEnabled: boolean;
}

/**
 * What the organisation's identity provider owns. `isMapped` covers the fields a customer maps; `scimEnabled`
 * covers email, phone number, role and licences, which SCIM owns for the whole organisation regardless of
 * mapping. Every card asks these the same way — two spellings of the question is how they drift apart.
 */
export const useMappedFields = (): MappedFields => {
  const { session, userDetails } = useStore();
  const organisation = session.user?.organisation;
  const mapped = new Set(organisation?.scimMappedFields ?? []);
  const isMapped = (field: IdpField): boolean => mapped.has(field);
  const unresolved = userDetails.details?.attributes?.unresolvedIdpValues ?? [];

  return {
    isMapped,
    // Nothing clears a record once its field is unmapped, and unmapping is the fix for a bad mapping.
    unresolvedFor: (field: IdpField) =>
      isMapped(field) ? unresolved.find((entry) => entry.field === field) : undefined,
    hasAny: mapped.size > 0,
    scimEnabled: !!organisation?.scimEnabled,
  };
};

export default useMappedFields;
